module.exports = __webpack_public_path__ + "02_bob_black.5029ec5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_bob_black.png
// module id = ZNyg
// module chunks = 0